import { styled } from '@mui/material/styles';
import { Card, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useColors } from '../../Context/ColorsContext';
import { MediaQuerys } from '../../styles/GlobalStyle';

const { mobile, tablet, desktop } = MediaQuerys;




export const ContainerTitle = styled('div')(({ marginLeft }) => {
    return {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        marginLeft: marginLeft ? marginLeft : null,
    }
})

export const ContainerPageTitle = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem'
    }
});

export const ContainerOptionsGraphics = styled('div')(() => {
    return {
        width: '100%',
        flexWrap: 'wrap',
        gap: '0.80rem',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row',
        margin: '10px 0',
    }
});

export const ContainerOption = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'center',
        gap: '0.50rem',
        flexDirection: 'row',
    }
});

export const OptionColor = styled('div')(({ customColor }) => {
    return {
        borderRadius: '2px',
        width: '13px',
        height: '13px',
        background: customColor,
    }
});

export const OptionTitle = styled('span')(() => {
    return {
        fontSize: '0.80rem',
        fontWeight: 'bold',
    }
})

export const ContainerFilters = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        gap: '0.50rem',
    }
});

export const ContainerTop = styled('div')(() => {
    return {
        height: '50%',
        width: '100%',
    }
})

export const ContainerBottom = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem',
        height: '50%',
        width: '100%',
    }
});

export const ContainerValidate = styled('div')(() => {
    return {
        height: '60vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
    }
})

export const CustomImg = styled('img')(() => {
    return {
        width: '800px',
        [desktop]: {
            width: '600px',
        }       
    }
})

export const ContainerGraphics = styled(Card)(({ width, height }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        height: '335px',
        width: '100%',
        padding: '10px',
        overflowX: 'auto !important',
        borderRadius: '10px',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        '&::-webkit-scrollbar': {
            height: '5px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        } 
    }
});

export const ContentGraphics = styled(Card)(({ width, height }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        height: height,
        width: width,
        padding: '10px',
        borderRadius: '10px',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
    }
});

export const CustomTitleGraphics = styled(Typography)(() => {
    return {
        marginLeft: '1rem',
        fontWeight: 'bold',
        fontSize: '14px',
    }
})

export const BtnDownload = styled(Button)(() => {
  const { colors } = useColors();   
  return {
    height: 30,
    width: 120,
    padding: "0 20px",
    backgroundColor: colors.buttonActionColor,
    color: colors.white,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.white
    }
  }
})